import { store } from '../store/store'
export default {
  toDecimal (val) {
    return +val.toFixed(store.state.settings.decimalAccuracy)
  }
}
